import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import Api from "../../Api/Api";

export default function CreditEditInput(props) {
  const { id, field, value, api } = props;
  const { creditList = [] } = props;
  const [inputValue, setInputValue] = React.useState(value || "");

  // ✅ IMPORTANT FIX
  React.useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  return (
    <Autocomplete
      freeSolo
      options={creditList || []}
      value={inputValue}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);

        api.setEditCellValue({
          id,
          field,
          value: newInputValue,
        });
      }}
      onChange={(event, newValue) => {
        const finalValue = newValue || "";

        setInputValue(finalValue);

        api.setEditCellValue({
          id,
          field,
          value: finalValue,
        });

        Api.post("/dashboard/update-credit", {
          row_id: String(id).replace("temp-", ""),
          credit_name: finalValue,
        }).catch((err) => {
          console.log(err);
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          variant="standard"
          placeholder="Select Credit"
          fullWidth
        />
      )}
      sx={{
        width: "100%",
        "& .MuiAutocomplete-inputRoot": {
          padding: "0 !important",
        },
      }}
    />
  );
}
